<template>
    <h1>Sign In</h1>
    <signin-form :recaptchakey="recaptchakey" :returnurl="returnurl"></signin-form>
    <p class="small mt-4">
        By signing up, you agree to the
        <a target="_blank" href="/Terms-of-Service-FumblAi.pdf">Terms of Service</a> and
        <a target="_blank" href="/Privacy-Statement-FumblAi.pdf">Privacy Policy</a>, including
        <a target="_blank" href="/cookie-policy">Cookie Use</a>.
    </p>
</template>
<script>
    import SigninForm from '../components/SigninForm'

    export default {
        props: ['recaptchakey', 'returnurl'],
        data: function () {
            return {};
        },
        components: {
            SigninForm
        }
    };
</script>